/**
 *  注意
 *  vue-router 4.0.8 
 *  4.0 版本和 3.0版本差异较大，使用时请参考 4.0 文档
 */

import { createRouter, createWebHashHistory } from 'vue-router'

import NotFoundMobile from '../pages/common/404mobile.vue'

// 主页index 和 登陆 login  components
import PageHome from '../pages/home/index.vue'
import PageStart from '../pages/start/index.vue'
import PageQuery from '../pages/start/query.vue'
import PageAuth from '../pages/start/auth.vue'
import PageFission from '../pages/start/fission.vue'

// 路由配置
const routes = [{
    path: '/start',
    name: 'start',
    component: PageStart
},
{
    path: '/query',
    name: 'query',
    component: PageQuery,
},
{
    path: '/auth',
    name: 'auth',
    component: PageAuth,
},
{
    path: '/home',
    name: 'home',
    component: PageHome
},
{
    path: '/fission',
    name: 'fission',
    component: PageFission
},
{
    path: '/404',
    // component: NotFoundPc
    component: NotFoundMobile
},
    // {   path: '/*', 
    //     redirect: '/404' 
    // }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
